/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'

/**
 * Typescript enum
 */

export enum BetKind {
  ALLIN = 'ALLIN',
  BET = 'BET',
  BIGBLIND = 'BIGBLIND',
  BLANK = 'BLANK',
  CALL = 'CALL',
  CHECK = 'CHECK',
  FOLD = 'FOLD',
  RAISE = 'RAISE',
  SMALLBLIND = 'SMALLBLIND'
}

/**
 * BetKind
 *
 * The possible bets that can be made
 */
export const BetKindEnumType = types.enumeration('BetKind', [
  'ALLIN',
  'BET',
  'BIGBLIND',
  'BLANK',
  'CALL',
  'CHECK',
  'FOLD',
  'RAISE',
  'SMALLBLIND'
])
